// @ts-nocheck
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import {
  ResponsiveContainer, Tooltip, PieChart, Pie, Cell,
} from "recharts";
import {
  DefinitionTooltip,
} from "src/components/common";
import {
  formatOrganicPostTypeLabel,
  getOrganicContentSectionDefinitionInfo,
} from "../OrganicMediaDefinitions";
import { formatNumber } from "src/utils/numberFormat";
import {
  DonutTooltip,
  withBidiIsolate,
} from "./InstagramContentHelpers";
import "../../../styles/InstagramContentReport/InstagramContentTypeBreakdown.scss";

type PostsByTypeSlice = {
  name: string;
  value: number;
  valueFormattedValue?: string;
  color: string;
};

const InstagramContentTypeBreakdown: FC<{
  chartPostsByType: PostsByTypeSlice[];
  pieLegendItems: PostsByTypeSlice[];
  pieLegendTotal: number;
}> = ({ chartPostsByType, pieLegendItems, pieLegendTotal }) => {
  const { t, i18n } = useTranslation();
  return (
    <div className="organic-content-panel organic-content-panel--content-breakdown">
      <div className="organic-content-panel__header">
        <div className="organic-content-panel__title">
          <h3>{t("organicMedia.instagram.sections.contentTypeBreakdown")}</h3>
          <DefinitionTooltip
            label={t("organicMedia.instagram.sections.contentTypeBreakdown")}
            info={getOrganicContentSectionDefinitionInfo("contentTypeBreakdown", t)}
            formulaTitle={t("organicMedia.common.formula")}
          />
        </div>
      </div>
      <div className="organic-content-panel__donut">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Tooltip
              content={<DonutTooltip />}
              allowEscapeViewBox={{ x: false, y: true }}
              wrapperStyle={{ pointerEvents: "none" }}
            />
            <Pie
              data={chartPostsByType}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius="58%"
              outerRadius="86%"
              startAngle={90}
              endAngle={-270}
              paddingAngle={0}
              labelLine={false}
            >
              {chartPostsByType.map(slice => (
                <Cell key={slice.name} fill={slice.color} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className="organic-content-panel__donut-center">
          <span className="organic-content-panel__donut-center-value">
            {formatNumber(pieLegendTotal, {}, i18n.language)}
          </span>
          <span className="organic-content-panel__donut-center-label">
            {t("organicMedia.contentReport.totalPosts")}
          </span>
        </div>
      </div>
      <div
        className={`organic-content-panel__pie-legend ${
          pieLegendItems.length > 3
            ? "organic-content-panel__pie-legend--columns"
            : "organic-content-panel__pie-legend--centered"
        }`}
        aria-hidden
      >
        {pieLegendItems.map(item => (
          <div
            key={`${item.name}-${item.value}`}
            className="organic-content-panel__pie-legend-item"
            >
              <span
                className="organic-content-panel__pie-legend-swatch"
                style={{ backgroundColor: item.color }}
              />
              <span className="organic-content-panel__pie-legend-text">
                {formatOrganicPostTypeLabel(item.name, t)}
              </span>
              <strong>
                {item.valueFormattedValue ?? formatNumber(Number(item.value ?? 0), {}, i18n.language)}
                {pieLegendTotal > 0
                  ? withBidiIsolate(
                      ` (${formatNumber((Number(item.value ?? 0) / pieLegendTotal) * 100, { minimumFractionDigits: 1, maximumFractionDigits: 1 }, i18n.language)}%)`,
                      i18n.language
                    )
                  : ""}
              </strong>
            </div>
        ))}
      </div>
    </div>
  );
};

export default InstagramContentTypeBreakdown;
